var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M614.417 260.812L496.01 418.688C488.385 428.844 476.729 434.688 464.01 434.688S439.635 428.844 432.01 418.656L195.198 102.938C186.073 90.688 165.948 90.719 156.823 102.906L38.417 260.812C35.76 264.375 30.729 265.031 27.198 262.406C23.667 259.75 22.948 254.75 25.604 251.188L144.01 93.312C159.26 73 192.76 72.969 208.01 93.344L444.823 409.062C453.948 421.312 474.073 421.281 483.198 409.094L601.604 251.188C604.26 247.688 609.323 247 612.823 249.594C616.354 252.25 617.073 257.25 614.417 260.812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTriangle);
export default __webpack_public_path__ + "static/media/wave-triangle.a17b0180d0d0a22cbcce29032f76d873.svg";
export { ForwardRef as ReactComponent };